import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Don't let transient network/rate-limit (429) blips surface as the red "Uncaught runtime
// errors" overlay. These are handled/retried by the axios interceptor; real code errors are
// untouched so genuine bugs still surface.
window.addEventListener("unhandledrejection", (e) => {
  const status = e?.reason?.response?.status;
  const code = e?.reason?.code;
  if (status === 429 || status === 503 || code === "ERR_NETWORK" || code === "ECONNABORTED") {
    e.preventDefault();
  }
});

// Swallow the benign "ResizeObserver loop" warning that Radix Dialog/Select emit; it is
// harmless but otherwise surfaces the dev-only red error overlay. Registered in the CAPTURE
// phase so it runs before CRA's webpack-dev-server error-overlay listener.
const _swallowResizeObserver = (e) => {
  const msg = e?.message || e?.reason?.message || "";
  if (msg.startsWith("ResizeObserver loop")) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
};
window.addEventListener("error", _swallowResizeObserver, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
